//jquery3.4.1 【npm install jquery --save】
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;

//library
// import jquery from './lib/jquery/jquery-2.2.4.min';
// import mousewheel from './lib/jquery.mousewheel.min.js';
// import easing from './lib/jquery.easing.1.3.js';
// import lity from './lib/lity.js';
// import cookie from './lib/jquery.cookie.js';
// import audiojs from './lib/audiojs/audio.min.js';
// import matchheight from './lib/jquery.matchHeight.js';

// jsファイルを読み込む
import common from './common';
// import index from './index';